<div style="overflow-x: hidden; scrollbar-width: none;">
  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>
  <form #df="ngForm" novalidate (keydown.enter)="onSearchBusinessData()" class="formborder">
    <div class="row m-0 col-md-12">
      <div class="col-md-2">
        <span class="required-lable"> From Date </span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY" name="FromDate" id="FromDate"
            #refFromDate="ngModel" class="form-control input-text-css" (dateChange)="DateChange()" required
            [(ngModel)]="FromDate" [ngClass]="{
              'is-invalid': df.submitted && refFromDate.invalid,
              'alert-warning':
                refFromDate.invalid &&
                (refFromDate.dirty ||
                  refFromDate.touched ||
                  refFromDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span class="required-lable"> To Date </span>
        <div class="datepicker_feild">
          <input [matDatepicker]="picker2" dateConvert placeholder="DD/MM/YYYY" name="ToDate" id="ToDate"
            #refToDate="ngModel" class="form-control input-text-css" (dateChange)="DateChange()" required
            [(ngModel)]="ToDate" [ngClass]="{
              'is-invalid': df.submitted && refToDate.invalid,
              'alert-warning':
                refToDate.invalid &&
                (refToDate.dirty || refToDate.touched || refToDate.untouched)
            }" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </div>
      </div>
      <div class="col-md-2">
        <span class="required-lable"> Report Type </span>
        <select name="ReportType" id="ReportType" [(ngModel)]="ReportType" class="form-control input-text-css"
          (change)="onChangeReportTypes()" required #refReportType="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refReportType.invalid,
            'alert-warning':
              refReportType.invalid &&
              (refReportType.dirty ||
                refReportType.touched ||
                refReportType.untouched)
          }">
          <option value="">Select Report Type</option>
          <option *ngFor="let row of ArrTypes" [value]="row.id">
            {{ row.value }}
          </option>
        </select>
      </div>
      <div class="col-md-2" *ngIf="SlabDropdown">
        <span class="required-lable">Slab Name</span>
        <select name="SlabId" id="SlabId" [(ngModel)]="SlabId" class="form-control input-text-css" required
          #refSlabId="ngModel" [ngClass]="{
            'is-invalid': df.submitted && refSlabId.invalid,
            'alert-warning':
              refSlabId.invalid &&
              (refSlabId.dirty || refSlabId.touched || refSlabId.untouched)
          }">
          <option value="''">Select Slab Name</option>
          <option *ngFor="let row of SlabData" [value]="row.Id">
            {{ row.Slab_name }}
          </option>
        </select>
      </div>
      <div class="col-md-2">
        <button type="button" (click)="onSearchBusinessData()" class="mt-3 btn font-size-12 button-btn"
          [disabled]="!df.form.valid">
          Search
        </button>
      </div>
      <div class="col-md-2 ml-4" [hidden]="!dataSourceTree">
        <!-- <button
          type="button"
          *ngIf="ExpandBtn"
          class="mt-3 btn font-size-10 button-btn"
          (click)="OnClickExpandAll()"
        >
          Expand All
        </button>
        <button
          type="button"
          *ngIf="CollaspeBtn"
          class="mt-3 btn font-size-12 button-btn"
          (click)="OnClickCollaspeAll()"
        >
          Collapse All
        </button> -->
      </div>
    </div>
  </form>

  <div class="row mt-3 tableGraph" *ngIf="dataSourceTree">
    <!-- Table: left half -->
    <div class="col-md-6 tableHeight"
      style="height: 50%; min-height: 350px; max-height: 490px; max-width: 100%; display: flex; flex-direction: column;">
      <div class="glass-table glass-tables-row" style="height: 100%;">
        <table mat-table [dataSource]="dataSourceTree" class="mat-elevation-z8" matSort matTableExporter
          #exporter="matTableExporter" style="height: 100%; overflow: auto; max-width: 100%;">
          <ng-container matColumnDef="Product_Name">
            <th mat-header-cell *matHeaderCellDef>
              Product
            </th>
            <td mat-cell *matCellDef="let data">
              <span (click)="productwiseDashboard(data); selectedProductRow = data;"
                style="cursor: pointer; color: #0056b3;">

                {{ data.Product_Name }}
              </span>
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-align"></th>
          </ng-container>
          <ng-container matColumnDef="Branch_Name">
            <th mat-header-cell *matHeaderCellDef>
              Branch
            </th>
            <td mat-cell *matCellDef="let data">

              <span (click)="branchwiseDashboard(data); selectedBranchRow = data"
                style="cursor: pointer; color: #0056b3;">
                {{ data.Branch_Name }}
              </span>
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-align"></th>
          </ng-container>

          <ng-container matColumnDef="NoOfLoans">
            <th mat-header-cell *matHeaderCellDef>NOS.</th>
            <td mat-cell *matCellDef="let data">
              {{ data.NoOfLoans }}
            </td>
            <th mat-footer-cell *matFooterCellDef class="text-right grid-header" style="font-weight: bold">
              {{ Math.round(totaltypewiseBranch1("NoOfLoans")) }}
            </th>
          </ng-container>

          <ng-container matColumnDef="TotalBusiness">
            <th mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Total
              Business</th>
            <td mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.TotalBusiness }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ Math.round(totaltypewiseBranch1("TotalBusiness")) }}
            </th>
          </ng-container>
          <ng-container matColumnDef="AvgLoanSize">
            <th mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Avg Loan
              Size</th>
            <td mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ (row.TotalBusiness /
              row.NoOfLoans).toFixed(2) }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{
              totaltypewiseBranch1("NoOfLoans") > 0
              ? Math.round(
              totaltypewiseBranch1("TotalBusiness") /
              totaltypewiseBranch1("NoOfLoans")
              )
              : 0
              }}
            </th>
          </ng-container>

          <ng-container matColumnDef="IN_Percentage">
            <th mat-header-cell *matHeaderCellDef>IN_Percentage</th>
            <td mat-cell *matCellDef="let data">{{
              data.IN_Percentage }}</td>
            <th mat-footer-cell *matFooterCellDef class="text-align">
              {{ Math.round(totaltypewiseBranch1("IN_Percentage")) }}%
            </th>
          </ng-container>
          <ng-container matColumnDef="Action">
            <th mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let row" class="grid-cell text-center">
              <i class="fa fa-arrow-circle-right arrow-circle action-btn" (click)="goToBookingListDetails(row)"
                *ngIf="row.NoOfLoans > 0" aria-label="true"></i>
            </td>
            <th mat-footer-cell *matFooterCellDef style="max-width: 100%"></th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedTreeColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; let i = index; columns: displayedTreeColumns"
            [ngClass]="{ 'branch-selected-row': selectedBranchRow === row }"
            [ngClass]="{ 'branch-selected-row': selectedProductRow === row }"></tr>

        </table>
      </div>
      <div class="row m-0 align-items-center" style="background: #fff">
        <div class="col-md-12 p-2">
          <button class="mt-3 btn font-size-12 button-btn" (click)="exportTable(exporter)">
            <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
            Export
          </button>
        </div>
      </div>
    </div>
    <div class="dashboard-container col-md-5" *ngIf="chartdata">

      <!-- Branch Summary -->
      <div class="dashboard-summary dashspecs">
        <div class="summary-title">Total Business</div>

        <div class="summary-card">
          <div class="label">Total No. Of Loans</div>
          <div class="value">{{ Math.round(totaltypewiseBranch1('NoOfLoans')) }}</div>
        </div>

        <div class="summary-card">
          <div class="label">Total Business</div>
          <div class="value">{{ Math.round(totaltypewiseBranch1('TotalBusiness')) }}</div>
        </div>

        <div class="summary-card">
          <div class="label">Avg Loan Size</div>
          <div class="value">
            {{ totaltypewiseBranch1('NoOfLoans') > 0
            ? Math.round(totaltypewiseBranch1('TotalBusiness') / totaltypewiseBranch1('NoOfLoans'))
            : 0 }}
          </div>
        </div>

        <div class="summary-card">
          <div class="label">IN Percentage</div>
          <div class="value">{{ Math.round(totaltypewiseBranch1('IN_Percentage')) }}%</div>
        </div>
      </div>

      <!-- Gender Breakdown -->
      <div class="breakdown-container" *ngIf="genderItem.length >= 1">
        <div class="breakdown-box">
          <div class="box-title">Gender Wise Breakdown</div>

          <div class="breakdown-flex">
            <!-- Male -->
            <div class="legend male">
              <div><span class="dot male"></span> Male</div>
              <div>Loans: <b>{{ maleLoans }}</b></div>
              <div>Amount: <b>₹{{ maleBusiness | number:'1.0-2' }}</b></div>
              <div>IN %: <b>{{ malePercentage | number:'1.2-2' }}%</b></div>
            </div>

            <!-- Donut Chart -->
            <div class="chart-wrapper">
              <svg viewBox="0 0 140 140" preserveAspectRatio="xMidYMid meet">
                <!-- Base Circle -->
                <circle cx="70" cy="70" r="60" stroke="#e3eaf3" stroke-width="12" fill="none" />
                <!-- Female Part -->
                <circle cx="70" cy="70" r="60" stroke="url(#femaleGradient)" stroke-width="12" fill="none"
                  [attr.stroke-dasharray]="getFemaleArc() + ',377'" stroke-linecap="round"
                  transform="rotate(-90 70 70)" />
                <!-- Male Part -->
                <circle cx="70" cy="70" r="60" stroke="url(#maleGradient)" stroke-width="12" fill="none"
                  [attr.stroke-dasharray]="getMaleArc() + ',377'" stroke-linecap="round"
                  [attr.transform]="'rotate(' + (-90 + getFemaleArc()) + ' 70 70)'" />

                <defs>
                  <linearGradient id="femaleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#ff6fa1" />
                    <stop offset="100%" stop-color="#ff94b6" />
                  </linearGradient>
                  <linearGradient id="maleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stop-color="#4d9fff" />
                    <stop offset="100%" stop-color="#6db3ff" />
                  </linearGradient>
                </defs>
              </svg>

              <!-- Center text -->
              <div class="center-text">
                <span class="big">{{ Total_Loan }}</span>
                <span class="small">Total Loans</span>
              </div>
            </div>

            <!-- Female -->
            <div class="legend female">
              <div><span class="dot female"></span> Female</div>
              <div>Loans: <b>{{ femaleLoans }}</b></div>
              <div>Amount: <b>₹{{ femaleBusiness | number:'1.0-2' }}</b></div>
              <div>IN %: <b>{{ femalePercentage | number:'1.2-2' }}%</b></div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div
      class="dashboard-tables  glass-table-scroll glass-tables-row d-flex flex-wrap justify-content-between align-items-stretch mt-4"
      style="width: 94%;">
      <div class="table-box glass-table-card flex-grow-1 mx-2 mb-3" *ngIf="maritalStatusItem.length >= 1"
        style="min-width: 320px; border: 1px solid #d0e7f8; border-radius: 12px; background:rgba(158, 207, 250, .3);">
        <div class="glass-table-header">Maritial Status Details</div>
        <table class="table glass-table">
          <thead>
            <tr>
              <th>Marital Status</th>
              <th>No. Of Loans</th>
              <th>Total Business</th>
              <th>IN Percentage</th>
              <th>Avg Loan Size</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of maritalStatusItem">
              <td>{{ row.Customer_MaritalStatus }}</td>
              <td>{{ row.Total_Loan }}</td>
              <td>{{ row.Total_Business | number:'1.0-2' }}</td>
              <td>{{ row.IN_Percentage }}</td>
              <td>{{ (row.Total_Business / row.Total_Loan).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-box glass-table-card flex-grow-1 mx-2 mb-3" *ngIf="productItem.length > 0"
        style="min-width: 320px;    border: 1px solid #d0e7f8; border-radius: 12px; background:rgba(158, 207, 250, .3);">
        <div class="glass-table-header">Product Wise Details</div>
        <table class="table glass-table">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>No. Of Loans</th>
              <th>Total Business</th>
              <th>IN Percentage</th>
              <th>Avg Loan Size</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of productItem">
              <td>{{ row.Product_Name }}</td>
              <td>{{ row.Total_Loan }}</td>
              <td>{{ row.Total_Business | number:'1.0-2' }}</td>
              <td>{{ row.IN_Percentage }}</td>
              <td>{{ (row.Total_Business / row.Total_Loan).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-box glass-table-card flex-grow-1 mx-2 mb-3" *ngIf="branchItem.length > 0"
        style="min-width: 320px;    border: 1px solid #d0e7f8; border-radius: 12px; background:rgba(158, 207, 250, .3);">
        <div class="glass-table-header">Branch Wise Details</div>
        <table class="table glass-table">
          <thead>
            <tr>
              <th>Branch Name</th>
              <th>No. Of Loans</th>
              <th>Total Business</th>
              <th>IN Percentage</th>
              <th>Avg Loan Size</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of branchItem">
              <td>{{ row.Branch_Name }}</td>
              <td>{{ row.Total_Loan }}</td>
              <td>{{ row.Total_Business | number:'1.0-2' }}</td>
              <td>{{ row.IN_Percentage }}</td>
              <td>{{ (row.Total_Business / row.Total_Loan).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-box glass-table-card flex-grow-1 mx-2 mb-3" *ngIf="salesExecItem.length >= 1"
        style="min-width: 320px;    border: 1px solid #d0e7f8; border-radius: 12px; background:rgba(158, 207, 250, .3);">
        <div class="glass-table-header">Sales Executive Details</div>
        <table class="table glass-table">
          <thead>
            <tr>
              <th>Sales Executive Name</th>
              <th>Total Loan</th>
              <th>Total Business</th>
              <th>IN Percentage</th>
              <th>Avg Loan Size</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of salesExecItem">
              <td>{{ row.Sales_Executive_Name }}</td>
              <td>{{ row.Total_Loan }}</td>
              <td>{{ row.Total_Business | number:'1.0-2' }}</td>
              <td>{{ row.IN_Percentage }}</td>
              <td>{{ (row.Total_Business / row.Total_Loan).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- ...existing code below... -->
  </div>

  <div class="row mt-3 tableGraph" *ngIf="DataDiv && !dataSourceTree">
    <div class="col-md-6 tableHeight">
      <div class="table-responsive">
        <mat-table [dataSource]="dataSource" matSort matTableExporter #exporter="matTableExporter">
          <ng-container matColumnDef="Id">
            <mat-header-cell mat-sort-header class="grid-header mw5" *matHeaderCellDef>#</mat-header-cell>
            <mat-cell *matCellDef="let row; let i = index" class="grid-cell mw5">
              {{ i + 1 }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="width: 57px"></mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Branch_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Branch Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Branch_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Gender">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Gender</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Gender }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Religion">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Religion</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Religion }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Cast">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Caste</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Cast }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="MaritalStatus">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Marital Status</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.MaritalStatus }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Customer_Profile">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Customer Profile</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Customer_Profile }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Natureofwork">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Nature of work
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Natureofwork }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Loan_Acc_Category">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Loan A\c Category</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Loan_Acc_Category }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="Product_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Product Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Product_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="SlabName">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Slab Name</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.SlabName }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="Employee_Name">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Sales Executive</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell">
              {{ row.Employee_Name }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-left grid-header">Total</mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="NoOfLoans">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>No. Of
              Loans</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.NoOfLoans }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("NoOfLoans") : "" }}
            </mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="TotalBusiness">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Total
              Business</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.TotalBusiness }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("TotalBusiness") : "" }}
            </mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="AvgLoanSize">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>Avg Loan
              Size</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ (row.TotalBusiness /
              row.NoOfLoans).toFixed(2) }}</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{
              dataSource
              ? (
              totaltypewise("TotalBusiness") /
              totaltypewise("NoOfLoans")
              ).toFixed(2)
              : ""
              }}
            </mat-footer-cell>
          </ng-container>
          <ng-container matColumnDef="IN_Percentage">
            <mat-header-cell mat-sort-header class="grid-header mw200 text-right" *matHeaderCellDef>IN
              Percentage</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell mw200 text-right">{{ row.IN_Percentage }}%</mat-cell>
            <mat-footer-cell *matFooterCellDef class="text-right grid-header">
              {{ dataSource ? totaltypewise("IN_Percentage") : "" }}
            </mat-footer-cell>
          </ng-container>

          <ng-container matColumnDef="Action">
            <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>Action</mat-header-cell>
            <mat-cell *matCellDef="let row" class="grid-cell text-center">
              <i class="fa fa-arrow-circle-right arrow-circle action-btn" (click)="goToBookingListDetails(row)"
                *ngIf="row.NoOfLoans > 0" aria-label="true"></i>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style="max-width: 100%"></mat-footer-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          <mat-footer-row class="sticky-footer fontcolor" *matFooterRowDef="displayedColumns"></mat-footer-row>
        </mat-table>
        <div class="row m-0 align-items-center" style="background: #fff">
          <div class="col-md-12 p-2">
            <button class="mt-3 btn font-size-12 button-btn" (click)="exportTable(exporter)">
              <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5 formborder d-flex justify-content-center align-items-center" *ngIf="chartdata">
      <app-charts [chartdata]="chartdata" [Types]="Types"></app-charts>
    </div>
  </div>
</div>

<div class="modal fade in" id="ViewBookingListDetails" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          View Details
        </h6>
        <button type="button" (click)="onCloseDueListDetails()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body">
        <div class="table-responsive">
          <mat-table [dataSource]="DataSourceModel" matSort matTableExporter #exporter="matTableExporter"
            style="height: 400px; max-width: 100%; overflow: auto">
            <ng-container [matColumnDef]="col" *ngFor="let col of displayedColumnsModel">
              <mat-header-cell mat-sort-header class="grid-header" *matHeaderCellDef>
                {{ columnDisplayNames[col] || col }}

              </mat-header-cell>
              <mat-cell *matCellDef="let row; let i = index" class="grid-cell">
                <div *ngIf="col == 'Id'">
                  {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
                </div>
                <div *ngIf="
                    currentUser.IsMaskingMobile && col == 'Customer_PhoneNo'
                  ">
                  {{ row[col] | mask }}
                </div>
                <div *ngIf="
                    !currentUser.IsMaskingMobile && col == 'Customer_PhoneNo'
                  ">
                  {{ row[col] }}
                </div>
                <div *ngIf="col != 'Customer_PhoneNo'">{{ row[col] }}</div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumnsModel; sticky: true"></mat-header-row>
            <mat-row (click)="highlightRow(row)" [class.highlight]="row.Loan_Id == selectedId"
              *matRowDef="let row; columns: displayedColumnsModel"></mat-row>
          </mat-table>

          <div class="row m-0 align-items-center d-flex justify-content-between align-items-center">
            <div class="col-md-2">
              <button class="mt-3 btn font-size-12 button-btn" (click)="exportTablebookinglist(exporter)">
                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                Export
              </button>
            </div>

            <div class="col-md-4 mt-1">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch" placeholder="What're you searching for?"
                      class="form-control border-0 bg-light" />
                    <div class="input-group-append">
                      <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-6">
              <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<table id="businesswise_model" class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none">
  <tr>
    <th *ngFor="let col of displayedColumnsModel" style="background: #4dc3a3 !important; border: 1px solid white">
      {{ col == "Id" ? "#" : col.split("_").join(" ") }}
    </th>
  </tr>
  <tr *ngFor="let row of FileCheckingList; let i = index" [ngClass]="row.level === 0 ? 'export-highlight' : ''">
    <td *ngFor="let col of displayedColumnsModel">
      <ng-container *ngIf="col === 'Product_Name' || col === 'Branch_Name'">
        {{ removePrefix(row[col]) }}
      </ng-container>
      <ng-container *ngIf="col !== 'Product_Name' && col !== 'Branch_Name'">
        {{
        col == "Id"
        ? paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1)
        : row[col]
        }}
      </ng-container>
    </td>
  </tr>
</table>